module.exports = __webpack_public_path__ + "img/DSC_0052.ab98cbcc.jpg";